import { projectsRoutesConfig } from 'domains/projects/routes';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useJWTs } from 'domains/jwtToken/hooks/useJWTs';
import { useTokenManagerConfigSelector } from 'domains/jwtToken/hooks/useTokenManagerConfigSelector';

/**
 * @deprecated This hook is deprecated; project selection should be refactored.
 * currently used for selecting the token for copy endpoints interface and chain projects sidebar
 */
export const useSelectedUserEndpointToken = () => {
  const {
    // TODO: remove if no issues with selected token appear
    // it is commented due to errors with copy endpoints on the chains list page with several projects
    // selectedProjectEndpointToken,
    tokenIndex,
  } = useTokenManagerConfigSelector();

  const {
    group,
    // userEndpointToken,
  } = useAccount();

  const { jwts, loading } = useJWTs({ group, skipFetching: true });

  // for project details page we should use the project selected via url params
  const { legacyProjectId, projectIndex } =
    projectsRoutesConfig.project.useParams();

  // the legacy projectId param is the endpoint token itself
  if (legacyProjectId) {
    return legacyProjectId;
  }

  if (loading) {
    return undefined;
  }

  if (projectIndex !== undefined) {
    return jwts.find(token => token.index === projectIndex)?.userEndpointToken;
  }

  // TODO: remove if no issues with selected token appear
  // it is commented due to errors with copy endpoints on the chains list page with several projects
  // if (selectedProjectEndpointToken) {
  //   return selectedProjectEndpointToken;
  // }

  // const isPrimaryProject = isPrimaryJWTIndex(tokenIndex);
  //
  // if (isPrimaryProject) {
  //   return userEndpointToken;
  // }

  const selectedToken = jwts.find(
    token => token.index === tokenIndex,
  )?.userEndpointToken;

  return selectedToken;
};
